jQuery(document).ready(function($) {
  if (!$('.how-it-work').length) {
    return;
  }

  howItWorks($);
});

function howItWorks($) {
  $(window).scroll(function() {
    const scroll = $(window).scrollTop();
    const previousSection = $('.how-it-work').prev();

    if(previousSection.length){
      if (scroll > (previousSection.offset().top*1-100) && scroll < ($('.how-it-work').offset().top*1+300)) {
        $('.animation-container').addClass('hover');
      } else {
        $('.animation-container').removeClass('hover');
      }
    }
  });

  if ($(window).width() <= 1280) {
    $('.animation-container').css(
      'transform',
      'scale(' + $(window).width() / 1280 + ')'
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/how-it-works.js